import { useVendorNotPermitted } from '@melio/ap-domain';
import { Group, Text } from '@melio/penny';
import { Vendor, VendorEBillStatusEnum } from '@melio/platform-api';

import { EbillCellBadge } from '../EbillsCellBadge/EBillCellBadge';
import { LockedVendorIcon } from '../LockedVendorIcon';
import { VendorAvatar } from '../VendorAvatar';

export type VendorAvatarWithDescriptionProps = {
  vendor: Vendor;
  description?: string;
};

export const VendorAvatarWithDescription = ({ vendor, description }: VendorAvatarWithDescriptionProps) => {
  const isVendorNotPermitted = useVendorNotPermitted(vendor);
  const { name: vendorName, externalLogoUrl: vendorExternalLogoUrl, isManaged: isVendorManaged } = vendor;
  return (
    <Group alignItems="center" data-testid="vendor-avatar-with-description">
      <VendorAvatar name={vendorName} logoUrl={vendorExternalLogoUrl} isManaged={isVendorManaged} />
      <Group variant="vertical" spacing="none">
        <Group alignItems="center" spacing="xxs" data-testid="vendor-avatar-with-description-name-container">
          {isVendorNotPermitted ? <LockedVendorIcon /> : null}
          <Text textStyle="body2Semi">{vendor.name}</Text>
          {vendor.eBillStatus !== VendorEBillStatusEnum.NotCapable && <EbillCellBadge vendor={vendor} />}
        </Group>
        {description ? (
          <Text textStyle="body4" color="neutral.darkest" shouldSupportEllipsis>
            {description}
          </Text>
        ) : null}
      </Group>
    </Group>
  );
};
